export const CHANGE_CURRENT_PAGE = 'tasksQueue/CHANGE_CURRENT_PAGE'
export const CHANGE_UPDATE_LANDINGS_TASKS_CURRENT_PAGE = 'tasksQueue/CHANGE_UPDATE_LANDINGS_TASKS_CURRENT_PAGE'
export const CHANGE_PAGE_SIZE = 'tasks/Queue/CHANGE_PAGE_SIZE'
export const CANCEL_TASK = 'tasksQueue/CANCEL_TASK'
export const FETCH_TASKS_LIST_PAGE = 'tasksQueue/FETCH_TASKS_LIST_PAGE'
export const RESTART_TASK = 'tasksQueue/RESTART_TASK'
export const TASK_LOADED = 'tasksQueue/TASK_LOADED'
export const FETCH_UPDATE_LANDINGS_TASK_LIST = 'tasksQueue/FETCH_UPDATE_LANDINGS_TASK_LIST'
